/* eslint-disable jira/filename-case, jira/import-whitelist, jira/naming/disallow-filenames */
import noop from 'lodash/noop';
import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls';
import { fg } from '@atlassian/jira-feature-gating';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { NAVIGATION_UI_STORAGE_KEY, LOGGER_LOCATION } from './navigationUiStorageKey.constants.tsx';
import type { UIControllerShape } from './UIControllerShape.types.tsx';

export const safeGetLocalStorage = ():
	| Storage
	| {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			setItem: (...args: any[]) => void;
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			getItem: (...args: any[]) => void;
	  } => {
	// eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
	if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') {
		// eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
		return window.localStorage;
	}

	return {
		setItem: noop,
		getItem: noop,
	};
};

const queryLocalStorageSync = (): UIControllerShape | undefined => {
	const localStorage = safeGetLocalStorage();
	const item = fg('jfp-vulcan-browser-storage-migration')
		? AtlBrowserStorageLocal.getItem(NAVIGATION_UI_STORAGE_KEY)
		: // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
			localStorage.getItem(NAVIGATION_UI_STORAGE_KEY);

	if (!__SERVER__ && item) {
		try {
			return JSON.parse(item);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			log.safeErrorWithoutCustomerData(LOGGER_LOCATION, 'Fail to parse sync local storage data', e);
		}
	}
};

export const queryLocalStorage = (): Promise<UIControllerShape | undefined> =>
	new Promise((resolve) => {
		const item = queryLocalStorageSync();
		resolve(item);
	});

export const updateLocalStorageData = (data: UIControllerShape): void => {
	const localStorage = safeGetLocalStorage();
	if (fg('jfp-vulcan-browser-storage-migration')) {
		// @browser-storage setter
		AtlBrowserStorageLocal.setStrictlyNecessaryItem(
			NAVIGATION_UI_STORAGE_KEY,
			JSON.stringify(data),
		);
	} else {
		// eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
		localStorage.setItem(NAVIGATION_UI_STORAGE_KEY, JSON.stringify(data));
	}
};
